import { useState } from 'react';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);

  /**
   * Check localStorage for an existing session.
   * Returns 'authenticated', 'onboarding', or 'unauthenticated'.
   * Sets isInitialized = true when complete so App.js knows it's safe to render.
   */
  const checkInitialAuth = () => {
    const token = localStorage.getItem('auth_token');
    const hasSeenOnboarding = localStorage.getItem('hasSeenOnboarding') === 'true';

    // Validate token is a real JWT (3 dot-separated parts)
    if (token && token.split('.').length === 3) {
      setIsAuthenticated(true);
      setIsInitialized(true);
      if (!hasSeenOnboarding) {
        setShowOnboarding(true);
        return 'onboarding';
      }
      return 'authenticated';
    }
    // Invalid or missing token — clear everything
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_name');
    setIsInitialized(true);
    return 'unauthenticated';
  };

  const login = () => setIsAuthenticated(true);

  const register = () => {
    setIsAuthenticated(true);
    setShowOnboarding(true);
  };

  const completeOnboarding = () => {
    localStorage.setItem('hasSeenOnboarding', 'true');
    setShowOnboarding(false);
  };

  const triggerOnboarding = () => setShowOnboarding(true);

  const logout = () => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
      }).catch(() => {});
    }
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_name');
    setIsAuthenticated(false);
  };

  return {
    isAuthenticated,
    isInitialized,
    showOnboarding,
    checkInitialAuth,
    login,
    register,
    completeOnboarding,
    triggerOnboarding,
    logout,
  };
}
